import { render, staticRenderFns } from "./angebote.vue?vue&type=template&id=1f1755d9&scoped=true&"
import script from "./angebote.vue?vue&type=script&lang=js&"
export * from "./angebote.vue?vue&type=script&lang=js&"
import style0 from "./angebote.vue?vue&type=style&index=0&id=1f1755d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1755d9",
  null
  
)

export default component.exports